<template>
  <div>
    <main>
      <v-container fluid grid-list-xl class="content-header">
        <v-layout row justify-space-between>
          <v-flex xs12 sm10 offset-sm1>
            <v-layout row justify-space-between class="vertical-align" style="min-height: 75px;">
              <v-flex sm6>
                <h3 class="headline mb-0">Suites Manager</h3>
              </v-flex>
              <v-flex sm6 class="text-xs-right" v-if="$route.name === 'suitesList'">
                <a
                  class="black--text"
                  @click="dialogCreateSuite = true">
                  <v-btn fab dark small color="primary">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                  New Suite
                </a>
              </v-flex> 
              <v-flex sm6 class="text-xs-right" v-if="$route.name === 'suitesGroups'">
                <a
                  class="black--text"
                  @click="dialogCreateGroup = true">
                  <v-btn fab dark small color="primary">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                  New group
                </a>
              </v-flex>           
            </v-layout>
            <v-card class="card--flex-toolbar mt-3">
              <v-layout row wrap color="primary" class="layout-adjustment">
                <router-link 
                  flat tag="v-btn" 
                  active-class="active" 
                  v-for="(tab, index) in tabs" 
                  :key="index" :to="tab.path" 
                  class="custom-btn"
                  >{{tab.title}}
                </router-link>
              </v-layout>
              <v-divider></v-divider>
              <router-view></router-view>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </main>

    <v-dialog v-model="dialogCreateSuite" max-width="500px">
      <createsuite-modal :modalType="modalType" v-if="dialogCreateSuite" @close="createSuiteModalClose" @submit="createSuiteModalClose"></createsuite-modal>
    </v-dialog>

    <v-dialog v-model="dialogCreateGroup" max-width="500px">
      <creategroup-modal v-if="dialogCreateGroup" @close="createGroupModalClose" @submit="createGroupModalClose"></creategroup-modal>
    </v-dialog>
  </div>
</template>

<script>
  import CreateSuite from '../modals/Suite';
  import CreateGroup from '../modals/SuiteGroup';

  export default {
    data() {
      return {
        tabs: [
          {
            title: 'Suites',
            path: { name: 'suitesList' },
          },
          {
            title: 'Suites groups',
            path: { name: 'suitesGroups' },
          },
        ],
        modalType: null,
        dialogCreateSuite: false,
        dialogCreateGroup: false,
      };
    },
    methods: {
      createModalTrigger(type) {
        this.modalType = type;
        this.dialogCreateSuite = true;
      },
      createSuiteModalClose(data) {
        if (data) {
          this.$store.dispatch('suite_pushSuite', data);
          this.dialogCreateSuite = false;
          return;
        }
        this.modalType = null;
        this.dialogCreateSuite = false;
      },
      createGroupModalClose(data) {
        if (data) {
          this.$store.dispatch('pushSuiteGroup', data);
        }
        this.dialogCreateGroup = false;
      },
    },
    components: {
      createsuiteModal: CreateSuite,
      creategroupModal: CreateGroup,
    },
  };
</script>

<style scoped lang="scss">
  main {
    padding-top: 64px;
  }
  
  .margin-off {
    margin-right: 0;
  }
  .layout-adjustment {
    margin: 0 !important;
    padding: 0 !important;

  }
  .custom-btn {
    justify-content: space-between;
    width: 50%;
    margin: 0 !important;
    height: 48px;

    &.active{
      background-color: #00838f !important;
      color: #fff !important;

      &::before {
        border-radius: inherit;
        color: inherit;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        opacity: 0.12;
        transition: .3s cubic-bezier(.25,.8,.5,1);
        width: 100%;
        background-color: #000 !important;
      }
    }
  }
  @media only screen and (max-width: 600px) {
    .custom-btn {
      width: 50%;
      &:nth-of-type(5){
        width: 100% !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/suitesManager/Index.vue